export default {
    show: 'បង្ហាញ',
    entries: 'ច្រកចូល',
    previous: 'មុន',
    next: 'បន្ទាប់',
    of: 'នៃ',
};
